import type { FC } from 'react';
import type { IconProps } from './types';

const FileXls: FC<IconProps> = ({ color = 'currentColor', size = 24, strokeWidth = 1.5, ...props }) => {
  const calculatedStrokeWidth = (Number(strokeWidth) * 24) / Number(size);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      color={color}
      fill="none"
      stroke={color}
      strokeWidth={calculatedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M20 13V10.6569C20 9.83935 20 9.4306 19.8478 9.06306C19.6955 8.69552 19.4065 8.40649 18.8284 7.82843L14.0919 3.09188C13.593 2.593 13.3436 2.34355 13.0345 2.19575C12.9702 2.165 12.9044 2.13772 12.8372 2.11401C12.5141 2 12.1614 2 11.4558 2C8.21082 2 6.58831 2 5.48933 2.88607C5.26731 3.06508 5.06508 3.26731 4.88607 3.48933C4 4.58831 4 6.21082 4 9.45584V13M13 2.5V3C13 5.82843 13 7.24264 13.8787 8.12132C14.7574 9 16.1716 9 19 9H19.5" />
      <path d="M10.5 16V20C10.5 20.9428 10.5 21.4142 10.7929 21.7071C11.0858 22 11.5572 22 12.5 22H14" />
      <path d="M4 16L6 19M6 19L8 22M6 19L8 16M6 19L4 22" />
      <path d="M20.0002 16H17.5C16.9477 16 16.5 16.4477 16.5 17V18C16.5 18.5523 16.9477 19 17.5 19H19.0002C19.5525 19 20.0002 19.4477 20.0002 20V21C20.0002 21.5523 19.5525 22 19.0002 22H16.5" />
    </svg>
  );
};

export default FileXls;
